var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-container",attrs:{"id":"page"},on:{"click":_vm.resetVersionCheck}},[_c('DefaultLayout',{attrs:{"showDashboard":_vm.showDashboard}},[_c('router-view')],1),(!_vm.hideBot)?_c('Bot',{attrs:{"id":"whatsapp-chat"}}):_vm._e(),_c('AppVersionCheck'),_c('CookiesConsent')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }